module.exports = __webpack_public_path__ + "static/route-cd590eb7f88ea933c3e7df10caaf7924.png";